// Scaling for 2 decimal places (cents)
const CURRENCY_SCALE_FACTOR = 100

export const roundAmount = (value: number): number => {
  return Math.round(value * CURRENCY_SCALE_FACTOR) / CURRENCY_SCALE_FACTOR
}
